import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [berichte, setBerichte] = useState([]);
  const [zeitheute, setZeitHeute] = useState([]);

  useEffect(() => {
    api.get('/stats').then(r => setStats(r.data)).catch(() => {});
    api.get('/bautagebuecher').then(r => setBerichte(r.data.slice(0, 5))).catch(() => {});
    api.get('/zeiterfassung').then(r => {
      const heute = new Date().toISOString().split('T')[0];
      setZeitHeute(r.data.filter(z => z.datum === heute).slice(0, 5));
    }).catch(() => {});
  }, []);

  const statusBadge = s => {
    if (s === 'aktiv') return <span className="badge badge-green">Aktiv</span>;
    if (s === 'entwurf') return <span className="badge badge-amber">Entwurf</span>;
    if (s === 'fertig') return <span className="badge badge-blue">Fertig</span>;
    return <span className="badge badge-grey">{s}</span>;
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Guten Tag, {user?.name?.split(' ')[0]} 👋</div>
          <div className="page-sub">{new Date().toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</div>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/bautagebuch/erstellen')}>
          + Neues Bautagebuch
        </button>
      </div>

      <div className="stat-grid">
        <div className="stat-card">
          <div className="stat-label">Aktive Baustellen</div>
          <div className="stat-value">{stats?.aktive_baustellen ?? '—'}</div>
          <div className="stat-sub">laufende Projekte</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Stunden diese Woche</div>
          <div className="stat-value">{stats?.stunden_woche ?? '—'}</div>
          <div className="stat-sub">{user?.role === 'admin' ? 'alle Mitarbeiter' : 'meine Stunden'}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Berichte heute</div>
          <div className="stat-value">{stats?.berichte_heute ?? '—'}</div>
          <div className="stat-sub">Bautagebücher</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Material-Warnung</div>
          <div className="stat-value" style={{ color: stats?.material_warn > 0 ? 'var(--red)' : 'var(--green)' }}>{stats?.material_warn ?? '—'}</div>
          <div className="stat-sub">{stats?.material_warn > 0 ? 'Positionen nachbestellen' : 'Bestand OK'}</div>
        </div>
      </div>

      <div className="grid-2">
        <div className="card">
          <div className="card-head">
            <div><div className="card-title">Letzte Bautagebücher</div></div>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate('/bautagebuch')}>Alle →</button>
          </div>
          {berichte.length === 0 ? (
            <div className="empty"><div className="empty-icon">📋</div><h3>Noch keine Berichte</h3><p>Erstelle deinen ersten Bericht.</p></div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>Datum</th><th>Baustelle</th><th>Status</th></tr></thead>
                <tbody>
                  {berichte.map(b => (
                    <tr key={b.id} onClick={() => navigate(`/bautagebuch/${b.id}/ansicht`)} style={{ cursor: 'pointer' }}>
                      <td style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 12 }}>{b.datum}</td>
                      <td>{b.baustelle_name || '–'}</td>
                      <td>{statusBadge(b.status)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="card">
          <div className="card-head">
            <div><div className="card-title">Zeiterfassung heute</div></div>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate('/zeiterfassung')}>Alle →</button>
          </div>
          {zeitheute.length === 0 ? (
            <div className="empty"><div className="empty-icon">⏱</div><h3>Noch keine Einträge heute</h3><p>Stempel dich über die Sidebar ein.</p></div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>Mitarbeiter</th><th>Ein</th><th>Aus</th><th>Std.</th></tr></thead>
                <tbody>
                  {zeitheute.map(z => (
                    <tr key={z.id}>
                      <td style={{ fontWeight: 500 }}>{z.user_name}</td>
                      <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{z.einstempel}</td>
                      <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{z.ausstempel || <span style={{ color: 'var(--green)', fontWeight: 600 }}>Aktiv</span>}</td>
                      <td style={{ fontWeight: 600 }}>{z.stunden ? `${z.stunden}h` : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
